var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-layout',[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$tc('auth.invalidLink')))]),_c('auth-buttons')],1)}
var staticRenderFns = []

export { render, staticRenderFns }